var map = {
	"./Showreel.mp4": 5732,
	"./nft/btrNft/video1.mp4": 28705,
	"./nft/btrNft/video2.mp4": 6975,
	"./nft/dirtydrops/video1.mp4": 12631,
	"./nft/dirtydrops/video2.mp4": 25829,
	"./nft/halloween/video1.mp4": 80288,
	"./nft/halloween/video2.mp4": 73427,
	"./nft/halloween/video3.mp4": 69805,
	"./nft/halloween/video4.mp4": 6297,
	"./nft/halloween/video5.mp4": 35344,
	"./nft/halloween/video6.mp4": 45846,
	"./nft/interior/video.mp4": 57354,
	"./nft/newcityartist/video1.mp4": 1067,
	"./nft/newcityartist/video2.mp4": 56791,
	"./nft/newcityartist/video3.mp4": 89523,
	"./nft/newcityartist/video4.mp4": 48142,
	"./nft/neweast/video.mp4": 50892,
	"./nft/newnames/video.mp4": 45287,
	"./projects/aag/video1.mp4": 8936,
	"./projects/aag/video2.mp4": 98115,
	"./projects/aag/video3.mp4": 25957,
	"./projects/bolshaya3d/1.mp4": 54632,
	"./projects/bolshaya3d/2.mp4": 62579,
	"./projects/bolshaya3d/3.mp4": 90311,
	"./projects/bolshaya3d/ping.mp4": 69280,
	"./projects/bolshaya3d/t34.mp4": 95456,
	"./projects/btr/video.mp4": 927,
	"./projects/comicHero/video1.mp4": 53730,
	"./projects/dirtyDrops/video.mp4": 78083,
	"./projects/discoverycity/video.mp4": 19071,
	"./projects/gazpromNCA/video.mp4": 51590,
	"./projects/guidekur/video.mp4": 97907,
	"./projects/khraniteli3d/cosmo.mp4": 21667,
	"./projects/khraniteli3d/ping.mp4": 80853,
	"./projects/khraniteli3d/t34.mp4": 78341,
	"./projects/koporye/video.mp4": 41056,
	"./projects/ladoga/appvideo.mp4": 80041,
	"./projects/memoGorodAnimate/video1.mp4": 28718,
	"./projects/memoGorodAnimate/video2.mp4": 88681,
	"./projects/memoGorodAnimate/video3.mp4": 98841,
	"./projects/memoMariinskiy/video.mp4": 24304,
	"./projects/memoVsevAnimate/video1.mp4": 31136,
	"./projects/memoVsevAnimate/video2.mp4": 62641,
	"./projects/mymoscow/video.mp4": 66202,
	"./projects/myviborg/appvideo.mp4": 72600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37518;